import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';

import { config } from '../../shared/smartadmin.config';
import { Observable  } from 'rxjs/Observable';

import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/of';
import 'rxjs/add/observable/empty';
import 'rxjs/add/operator/retry'; // don't forget the imports
import { Console } from '@angular/core/src/console';
import { ResultData } from '../model/trjireh-model';
import { take } from 'rxjs/operators';

@Injectable()
export class ReportesApiService {
  data: any[] = [];

  reportesURL: string = config.API_DATA_URL + "/reportes";
  reportePDF: string = config.API_DATA_URL + "/PdfCreator";

  constructor(public http: HttpClient) {}

  public ReporteGeneral(filtro: any) {
    const headers = this.getHeaders();
    const param = JSON.stringify(filtro);
    // console.log(param);
    return this.http
      .post(this.reportesURL + "/ReporteGeneral", param, { headers })
      .map((resultado: any) => {
        return resultado;
      })
      .catch((error: any) => {
        console.error(error);
        return Observable.throw(new Error(error.status));
      });
  }

  public GetSucursales<T>() {
    const headers = this.getHeaders();
    return this.http
      .get<T>(this.reportesURL + "/GetSucursales", { headers })
      .pipe(take(1))
      .toPromise();
    // return this.http.get(this.reportesURL + '/GetSucursales', { headers })
    //     .map((response: any) => {
    //         this.data = response;
    //         return this.data;
    //     })
    //     .catch(this.handleError);
  }

  public async GetReporte<T>(url: string, parametros: any): Promise<T> {
    const headers = this.getHeaders();
    const param = JSON.stringify(parametros);

    return await this.http
      .post<T>(this.reportesURL + "/" + url, param, { headers })
      .pipe(take(1))
      // .retry(3)
      .catch((err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          // A client-side or network error occurred. Handle it accordingly.
          console.error("An error occurred:", err.error.message);
        } else {
          // The backend returned an unsuccessful response code.
          // The response body may contain clues as to what went wrong,
          console.error(
            `Backend returned code ${err.status}, body was: ${err.error}`,
          );
        }

        return Observable.throw(err);
      })
      .toPromise();

    // return this.http.post<T>(this.reportesURL + '/' + url, param, { headers })
    //     .map((resultado: T) => {
    //         return resultado;
    //     })
    //     .catch((error: any) => {
    //         return Observable.throw(new Error(error.status));
    //     });
  }

  public ReporteDireccionFiltro(filtro: any) {
    const headers = this.getHeaders();
    const param = JSON.stringify(filtro);
    // console.log(param);
    return this.http
      .post(this.reportesURL + "/ReporteDireccion", param, { headers })
      .map((resultado: any) => {
        return resultado;
      })
      .catch((error: any) => {
        return Observable.throw(new Error(error.status));
      });
  }

  public ReporteDireccionFiltroV2(filtro: any) {
    const headers = this.getHeaders();
    const param = JSON.stringify(filtro);
    // console.log(param);
    return this.http
      .post(this.reportesURL + "/ReporteDireccionV2", param, { headers })
      .map((resultado: any) => {
        return resultado;
      })
      .catch((error: any) => {
        return Observable.throw(new Error(error.status));
      });
  }

  public async ReporteDireccionExportar(filtro: any) {
    const httpOption: Object = {
      observe: "response",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      }),
      responseType: "arraybuffer",
    };

    const param = JSON.stringify(filtro);

    return await this.http
      .post(this.reportesURL + "/ReporteDireccion", param, httpOption)
      .toPromise();
  }

  public async ReporteDireccionExportarV2(filtro: any) {
    const httpOption: Object = {
      observe: "response",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      }),
      responseType: "arraybuffer",
    };

    const param = JSON.stringify(filtro);

    return await this.http
      .post(this.reportesURL + "/ReporteDireccionV2", param, httpOption)
      .toPromise();
  }

  public HisotricoUnidad(): Observable<any> {
    const headers = this.getHeaders();

    return this.http
      .get(this.reportesURL + "/HistoricoUnidad", { headers })
      .map((response: any) => {
        this.data = response;
        return this.data;
      })
      .catch(this.handleError);
  }

  public HisotricoUnidadFiltro(filtro: any) {
    const headers = this.getHeaders();
    const param = JSON.stringify(filtro);
    // console.log(param);
    return this.http
      .post(this.reportesURL + "/HistoricoUnidad", param, { headers })
      .map((resultado: any) => {
        return resultado;
      })
      .catch((error: any) => {
        return Observable.throw(new Error(error.status));
      });
  }

  public async HisotricoUnidadExportar(filtro: any) {
    const httpOption: Object = {
      observe: "response",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      }),
      responseType: "arraybuffer",
    };

    const param = JSON.stringify(filtro);

    // const headers = this.getHeaders();
    // const param = JSON.stringify(filtro);
    // // console.log(param);
    return await this.http
      .post(this.reportesURL + "/HistoricoUnidad", param, httpOption)
      .toPromise();
    // await this.http.post(this.reportesURL + '/HistoricoUnidad', param, httpOption )
    //     .map((resultado: any) => {
    //         return resultado;
    //     })
    //     .catch((error: any) => {
    //         return Observable.throw(new Error(error.status));
    //     });
  }

  public async ExportarExcel(ruta: string, filtro: any) {
    const httpOption: Object = {
      observe: "response",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      }),
      responseType: "arraybuffer",
    };

    const param = JSON.stringify(filtro);

    return await this.http
      .post(this.reportesURL + "/" + ruta, param, httpOption)
      .toPromise();
  }

  public UnidadesIngresadas(filtro: any) {
    const headers = this.getHeaders();
    const param = JSON.stringify(filtro);
    // console.log(param);
    return this.http
      .post(this.reportesURL + "/UnidadesIngresadas", param, { headers })
      .pipe(take(1))
      .map((resultado: any) => {
        return resultado;
      })
      .catch((error: any) => {
        return Observable.throw(new Error(error.status));
      });
  }

  public EstimadoUnidad(filtro: any) {
    const headers = this.getHeaders();
    const param = JSON.stringify(filtro);
    // console.log(param);
    return this.http
      .post(this.reportesURL + "/EstimadoUnidad", param, { headers })
      .map((resultado: any) => {
        return resultado;
      })
      .catch((error: any) => {
        return Observable.throw(new Error(error.status));
      });
  }

  public UnidadesProceso(filtro: any) {
    const headers = this.getHeaders();
    const param = JSON.stringify(filtro);
    // console.log(param);
    return this.http
      .post(this.reportesURL + "/UnidadesProceso", param, { headers })
      .map((resultado: any) => {
        return resultado;
      })
      .catch((error: any) => {
        return Observable.throw(new Error(error.status));
      });
  }

  public ProveedoresCredito(filtro: any) {
    const headers = this.getHeaders();
    const param = JSON.stringify(filtro);
    // console.log(param);
    return this.http
      .post(this.reportesURL + "/ProveedoresCredito", param, { headers })
      .map((resultado: any) => {
        return resultado;
      })
      .catch((error: any) => {
        return Observable.throw(new Error(error.status));
      });
  }

  public ReporteUtilidades(filtro: any) {
    const headers = this.getHeaders();
    const param = JSON.stringify(filtro);

    return this.http
      .post(this.reportesURL + "/ReporteUtilidades", param, { headers })
      .map((resultado: any) => {
        return resultado;
      })
      .catch((error: any) => {
        return Observable.throw(new Error(error.status));
      });
  }

  public ActualizarObservaciones(terminada: any) {
    const headers = this.getHeaders();
    const param = JSON.stringify(terminada);
    // console.log(param);
    return this.http
      .post(this.reportesURL + "/ActualizarObservaciones", param, {
        responseType: "blob" as "json",
      })
      .map((resultado: any) => {
        return resultado;
      })
      .catch((error: any) => {
        return Observable.throw(new Error(error.status));
      });
  }

  public buscarPDF() {
    const headers = this.getHeaders();

    return this.http
      .get(this.reportesURL + "/CreatePDF", { headers })
      .map((response: any) => {
        this.data = response;
        return this.data;
      })
      .catch(this.handleError);
  }

  public ResumenGerencial(filtro: any) {
    const headers = this.getHeaders();
    const param = JSON.stringify(filtro);
    // console.log(param);
    return this.http
      .post(this.reportesURL + "/ResumenGerencial", param, { headers })
      .map((resultado: any) => {
        return resultado;
      })
      .catch((error: any) => {
        return Observable.throw(new Error(error.status));
      });
  }

  public MensualAutorizadoAseguradora(filtro: any) {
    const headers = this.getHeaders();
    const param = JSON.stringify(filtro);
    // console.log(param);
    return this.http
      .post(this.reportesURL + "/MensualAutorizadoAseguradora", param, {
        headers,
      })
      .map((resultado: any) => {
        return resultado;
      })
      .catch((error: any) => {
        return Observable.throw(new Error(error.status));
      });
  }

  public ReporteRefacciones(filtro: any) {
    const headers = this.getHeaders();
    const param = JSON.stringify(filtro);
    // console.log(param);
    return this.http
      .post(this.reportesURL + "/ReporteRefacciones", param, {
        headers,
      })
      .map((resultado: any) => {
        return resultado;
      })
      .catch((error: any) => {
        return Observable.throw(new Error(error.status));
      });
  }

  private getBaseUrl() {
    return (
      location.protocol +
      "//" +
      location.hostname +
      (location.port ? ":" + location.port : "") +
      "/"
    );
  }

  private getHeaders(): HttpHeaders {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
    });

    return headers;
  }

  private handleError(error: any) {
    // In a real world app, we might use a remote logging infrastructure
    // We'd also dig deeper into the error to get a better message
    const errMsg = error.message
      ? error.message
      : error.status
        ? `${error.status} - ${error.statusText}`
        : "Server error";
    console.error(errMsg); // log to console instead
    return Observable.throw(errMsg);
  }
}



// WEBPACK FOOTER //
// C:/Users/stivens/Lab/sonever/repos/taller-web/src/app/core/api/reportes-api.service.ts